/**
 * Debounce function
 *
 * @param {Function} func function to debounce
 * @param {number} timeout debounce period
 * @returns {Function} debounced function
 */
function debounce(func, timeout = 500) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

/**
 * Gets node value and parse
 *
 * @param {Node} currentFrom dom element
 * @param {Node} currentTo dom element
 * @returns {Array} array with parsed values
 */
function getParsed(currentFrom, currentTo) {
  const from = parseFloat(parseFloat(currentFrom.value).toFixed(2));
  const to = parseFloat(parseFloat(currentTo.value).toFixed(2));
  return [from, to];
}

/**
 * fillSlider
 *
 * @param {Node} from min node
 * @param {Node} to max node
 * @param {Node} sliderColor slider color
 * @param {Node} rangeColor range color
 * @param {Node} controlSlider max slider
 */
function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
  const rangeDistance = to.max - 0;
  const fromPosition = from.value - 0;
  let toPosition;
  const [fromFormatted, toFormatted] = getParsed(from, to);
  if (fromFormatted >= toFormatted) toPosition = Number(from.value);
  else toPosition = to.value - 0;
  controlSlider.style.background = `linear-gradient(
    to right,
    ${sliderColor} 0%,
    ${sliderColor} ${((fromPosition) / (rangeDistance)) * 100}%,
    ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
    ${rangeColor} ${((toPosition) / (rangeDistance)) * 100}%,
    ${sliderColor} ${((toPosition) / (rangeDistance)) * 100}%,
    ${sliderColor} 100%)`;
}

/**
 * setToggleAccessible
 *
 * @param {Node} currentTarget target
 */
function setToggleAccessible(currentTarget) {
  const toSlider = currentTarget.closest('[data-price-range-wrapper]').querySelector('.range_container [data-to-slider]');
  if (Number(currentTarget.value) <= 0) {
    toSlider.style.zIndex = 2;
  } else {
    toSlider.style.zIndex = 0;
  }
}

/**
 * controlFromInput
 *
 * @param {Node} fromSlider min input range
 * @param {Node} fromInput min input number
 * @param {Node} toInput max input number
 * @param {Node} controlSlider max slider
 */
function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
  const [from, to] = getParsed(fromInput, toInput);
  fillSlider(fromInput, toInput, '#C6C6C6', '#221b10', controlSlider);
  if (from > to) {
    fromSlider.value = to;
    fromInput.value = to;
  } else {
    fromSlider.value = from;
  }
}

/**
 * controlToInput
 *
 * @param {Node} toSlider max input range
 * @param {Node} fromInput min input number
 * @param {Node} toInput max input number
 * @param {Node} controlSlider max slider
 */
function controlToInput(toSlider, fromInput, toInput, controlSlider) {
  const [from, to] = getParsed(fromInput, toInput);
  fillSlider(fromInput, toInput, '#C6C6C6', '#221b10', controlSlider);
  setToggleAccessible(toInput);
  if (from <= to) {
    toSlider.value = to;
    toInput.value = to;
  } else {
    toInput.value = from;
  }
}

/**
 * controlFromSlider
 *
 * @param {Node} fromSlider min input range
 * @param {Node} toSlider max input range
 * @param {Node} fromInput min input number
 */
function controlFromSlider(fromSlider, toSlider, fromInput) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider, '#C6C6C6', '#221b10', toSlider);
  if (from > to) {
    fromSlider.value = to;
    fromInput.value = to;
  } else {
    fromInput.value = from;
    fromSlider.value = from;
  }
}

/**
 * controlToSlider
 *
 * @param {Node} fromSlider min input range
 * @param {Node} toSlider max input range
 * @param {Node} toInput max input number
 */
function controlToSlider(fromSlider, toSlider, toInput) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider, '#C6C6C6', '#221b10', toSlider);
  setToggleAccessible(toSlider);
  if (from <= to) {
    toSlider.value = to;
    toInput.value = to;
  } else {
    toInput.value = from;
    toSlider.value = from;
  }
}

/**
 * Initiate slider
 *
 */
function initiateSlider() {
  document.querySelectorAll('[data-price-range-wrapper]').forEach((item) => {
    fillSlider(
      item.querySelector('.range_container [data-from-slider]'),
      item.querySelector('.range_container [data-to-slider]'),
      '#C6C6C6',
      '#221b10',
      item.querySelector('.range_container [data-to-slider]'),
    );
  });

  document.querySelectorAll('.range_container [data-to-slider]').forEach((item) => {
    setToggleAccessible(item);
  });
}

/**
 * Add listeners
 *
 */
function addListeners() {
  // gets all input range responsible for minimum price
  document.querySelectorAll('.range_container [data-from-slider]').forEach((item) => {
    item.addEventListener('input', (e) => {
      e.stopImmediatePropagation();
      controlFromSlider(
        e.target,
        e.target.closest('.sliders_control').querySelector('[data-to-slider]'),
        e.target.closest('[data-price-range-wrapper]').querySelector('[name="filter.v.price.gte"]'),
      );
    });
    item.addEventListener('change', (e) => {
      e.target.closest('[data-price-range-wrapper]').querySelector('[name="filter.v.price.gte"]').dispatchEvent(new Event('input', { bubbles: true }));
    });
  });

  // gets all input range responsible for maximum price
  document.querySelectorAll('.range_container [data-to-slider]').forEach((item) => {
    item.addEventListener('input', (e) => {
      e.stopImmediatePropagation();
      controlToSlider(
        e.target.closest('.sliders_control').querySelector('[data-from-slider]'),
        e.target,
        e.target.closest('[data-price-range-wrapper]').querySelector('[name="filter.v.price.lte"]'),
      );
    });
    item.addEventListener('change', (e) => {
      e.target.closest('[data-price-range-wrapper]').querySelector('[name="filter.v.price.lte"]').dispatchEvent(new Event('input', { bubbles: true }));
    });
  });

  // gets all input number responsible form minimum price
  document.querySelectorAll('[name="filter.v.price.gte"]').forEach((item) => {
    item.addEventListener('input', debounce((e) => {
      controlFromInput(
        e.target.closest('[data-price-range-wrapper]').querySelector('.range_container [data-from-slider]'),
        e.target,
        e.target.closest('price-range').querySelector('[name="filter.v.price.lte"]'),
        e.target.closest('[data-price-range-wrapper]').querySelector('.range_container [data-to-slider]'),
      );
    }));
  });

  // gets all input number responsible form maximum price
  document.querySelectorAll('[name="filter.v.price.lte"]').forEach((item) => {
    item.addEventListener('input', debounce((e) => {
      controlToInput(
        e.target.closest('[data-price-range-wrapper]').querySelector('.range_container [data-to-slider]'),
        e.target.closest('price-range').querySelector('[name="filter.v.price.gte"]'),
        e.target,
        e.target.closest('[data-price-range-wrapper]').querySelector('.range_container [data-to-slider]'),
      );
    }));
  });
}

/**
 * init
 *
 */
function init() {
  initiateSlider();
  addListeners();
}

init();

window.customVariables.addPriceRangeListeners = init;
